export default __webpack_public_path__ + "static/media/ic_type_exercise.56e04353.svg";